import React, { useState, useRef, useEffect } from 'react';
import { PageToolbar } from '../common';

/**
 * ItemsHeader - Header component for Items page
 * Contains: page title with count, import/export menu, add button, toolbar with category filter
 */
const ItemsHeader = ({
  isAdmin,
  filteredCount,
  searchTerm,
  onSearchChange,
  onScan,
  viewMode,
  onToggleView,
  onAddItem,
  categories,
  selectedCategory,
  onCategoryChange,
  onExport,
  onImport,
  importing
}) => {
  const [showDataMenu, setShowDataMenu] = useState(false);
  const menuRef = useRef(null);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setShowDataMenu(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleExport = () => {
    setShowDataMenu(false);
    onExport();
  };

  const handleImport = () => {
    setShowDataMenu(false);
    onImport();
  };

  return (
    <div className="page-header">
      <div className="header-top">
        <div className="header-left">
          <h1>Items</h1>
          <span className="item-count">{filteredCount} items</span>
        </div>
        <div className="header-buttons">
          {isAdmin && (
            <>
              <div className="data-menu-wrapper" ref={menuRef}>
                <button
                  className="export-btn"
                  onClick={() => setShowDataMenu(!showDataMenu)}
                  disabled={importing}
                >
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                    <polyline points="7 10 12 15 17 10" />
                    <line x1="12" y1="15" x2="12" y2="3" />
                  </svg>
                  {importing ? 'Importing...' : 'Import / Export'}
                  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" style={{ marginLeft: '4px' }}>
                    <polyline points="6 9 12 15 18 9" />
                  </svg>
                </button>
                {showDataMenu && (
                  <div className="data-dropdown">
                    <button onClick={handleExport}>
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                        <polyline points="7 10 12 15 17 10" />
                        <line x1="12" y1="15" x2="12" y2="3" />
                      </svg>
                      Export to CSV
                    </button>
                    <button onClick={handleImport}>
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                        <polyline points="17 8 12 3 7 8" />
                        <line x1="12" y1="3" x2="12" y2="15" />
                      </svg>
                      Import from CSV
                    </button>
                  </div>
                )}
              </div>
              <button className="add-button" onClick={onAddItem}>
                + Add Item
              </button>
            </>
          )}
        </div>
      </div>

      <PageToolbar
        viewMode={viewMode}
        onViewModeChange={onToggleView}
        searchTerm={searchTerm}
        searchPlaceholder="Search by name, part # or UPC..."
        onSearchChange={onSearchChange}
        showScanButton={true}
        onScan={onScan}
      >
        <select
          value={selectedCategory}
          onChange={(e) => onCategoryChange(e.target.value)}
          className="filter-select"
        >
          <option value="">All Categories</option>
          {categories.map((cat) => (
            <option key={cat.id} value={cat.id}>
              {cat.name}
            </option>
          ))}
        </select>
      </PageToolbar>
    </div>
  );
};

export default ItemsHeader;
